import React from 'react'
import { useSelector } from 'react-redux'

export default function SideBarManager({ path, children }) {
    const currentResultUrl = useSelector((state) => state.demoProcess.currentResultUrl)
    return (
        <>{(currentResultUrl === path) ? <>{children}</> : <></>}</>
    )
}
